import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '@/views/Home.vue'
import About from '@/views/About.vue'
import Admin from '@/views/Admin.vue'
import Iso from '@/views/Iso.vue'
import IndoorProduct from '@/views/IndoorProduct.vue'
import OutdoorProduct from '@/views/OutdoorProduct.vue'
import Contact from '@/views/Contact.vue'
import Dashboard from '@/views/Dashboard.vue'
import ProductView from '@/views/ProductView.vue'
Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: '/rolunk',
    name: 'Rolunk',
    component: About
  },
  {
    path: '/belteri',
    name: 'Berlteri',
    component: IndoorProduct
  },
  {
    path: '/kulteri',
    name: 'Kulteri',
    component: OutdoorProduct
  }, 
  {
    path: '/admin',
    name: 'Admin',
    component: Admin
  },
  {
    path: '/iso',
    name: 'Iso',
    component: Iso
  },
  {
    path: '/kapcsolat',
    name: 'Kapcsolat',
    component: Contact
  },
  {
    path: '/termek/:id',
    component: ProductView,
  },
  {
    path: '/dashboard',
    name: 'Dashboard',
    component: Dashboard
  },
  { 
    path: '/:catchAll(.*)', 
    component: Home,
    name: 'NotFound'
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
